import { useDebriefDispatch, useDebriefSelector } from 'ff/debrief/hooks';
import {
    selectFilterEndDate,
    selectFilterStartDate,
    selectFuzzySearchTerm,
    actions,
} from 'ff/debrief/features/AppSlice';
import { Segment } from 'ff/debrief/models';

export const useDebriefApp = () => {
    const dispatch = useDebriefDispatch();

    const isShareApp = useDebriefSelector(s => s.appSlice.isShareApp);
    const isToastOpen = useDebriefSelector(s => s.appSlice.toast.isOpen);
    const isChartOpen = useDebriefSelector(s => s.appSlice.isChartOpen);
    const selectedSegment = useDebriefSelector(s => s.appSlice.selectedSegment);
    const isDecluttering = useDebriefSelector(s => s.appSlice.isDecluttering);
    const isHidingSegmentDetails = useDebriefSelector(
        s => s.appSlice.isHidingScoreDetails
    );

    const startDate = useDebriefSelector(selectFilterStartDate);
    const endDate = useDebriefSelector(selectFilterEndDate);

    const fuzzySearchTerm = useDebriefSelector(selectFuzzySearchTerm);

    const openToast = (message: string) => {
        dispatch(actions.setToastState(true));
        dispatch(actions.setToastMessage(message));
    };

    const closeToast = () => {
        dispatch(actions.setToastState(false));
        dispatch(actions.setToastMessage(''));
    };

    const setStartDate = (newStartDate: number) => {
        dispatch(actions.setFilterStartDate(newStartDate));
    };

    const setEndDate = (newEndDate: number) => {
        dispatch(actions.setFilterEndDate(newEndDate));
    };

    const setFuzzySearch = (term: string) => {
        dispatch(actions.setFuzzySearchTerm(term));
    };

    const toggleChartOpen = () => {
        dispatch(actions.setChartOpen(!isChartOpen));
    };

    const selectSegment = (seg: Segment) => {
        dispatch(actions.setSelectedSegment(seg));
    };

    const hideScoreDetails = () => {
        dispatch(actions.setHideScoreDetails(true));
    };

    const toggleDecluttering = () => {
        dispatch(actions.setDecluttering(!isDecluttering));
    };

    const showScoreDetails = () => {
        dispatch(actions.setHideScoreDetails(false));
    };

    const toggleScoreDetails = () => {
        if (isHidingSegmentDetails) {
            dispatch(actions.setHideScoreDetails(false));
        } else {
            dispatch(actions.setHideScoreDetails(true));
        }
    };

    const scrollSegmentIntoView = (segmentId?: string): void => {
        const el = document.getElementById(segmentId || selectedSegment.id);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return {
        isShareApp,
        isToastOpen,
        isDecluttering,
        isHidingSegmentDetails,
        isChartOpen,
        selectedSegment: selectedSegment,
        filterStartTimestamp: startDate,
        filterEndTimestamp: endDate,
        fuzzySearchTerm: fuzzySearchTerm,
        openToast,
        closeToast,
        setFilterStartTimestamp: setStartDate,
        setFilterEndTimestamp: setEndDate,
        setFuzzySearchTerm: setFuzzySearch,
        selectSegment: selectSegment,
        scrollSegmentIntoView: scrollSegmentIntoView,
        hideScoreDetails: hideScoreDetails,
        showScoreDetails: showScoreDetails,
        toggleScoreDetails: toggleScoreDetails,
        toggleChartOpen: toggleChartOpen,
        toggleDecluttering: toggleDecluttering,
    };
};
